import React, { useState } from "react";
import { useQuery } from "react-query";
import { getServicesOrders } from "../../../service";
import { useBranchContext } from "../../../contexts/branch-context";

export const ServicesOrdersList: React.FC<any> = ({
  height,
  setOpen,
  setReservationId
}) => {
  const { currentBranch } = useBranchContext();
  const [orders, setOrders] = useState<any>([]);

  useQuery<any, Error>(
    ["/service-orders", currentBranch?.id],
    () => getServicesOrders(currentBranch?.id),
    {
      onSuccess(data) {
        setOrders(data);
      },
      enabled: !!currentBranch,
    }
  );

  return (
    <div
      style={{
        height: `calc(100vh - ${height}px)`,
        minHeight: `calc(100vh - ${height}px)`,
        maxHeight: `calc(100vh - ${height}px)`,
        overflow: "auto",
        background: "var(--color-surface)",
      }}
    >
      {orders.map((e: any) => {
        return (
          <>
            <div
              style={{
                paddingLeft: "5px",
                paddingRight: "5px",
                paddingTop: "10px",
                paddingBottom: "10px",
                fontWeight: "600",
                background: "var(--color-background-secondary)",
              }}
            >
              {e.day.name}
            </div>
            {e.orders.map((order: any) => {
              return (
                <div
                  onClick={() => {
                    setReservationId(order.id)
                    setOpen(true);
                  }}
                  style={{
                    width: "100%",
                    background: "var(--color-surface)",
                    borderLeft: "1px solid var(--color-border-light)",
                    borderRight: "1px solid var(--color-border)",
                    borderBottom: "1px solid var(--color-border-light)",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    cursor: "pointer",
                  }}
                >
                  {order.content.map((row: any) => {
                    return (
                      <div
                        style={{
                          display: row.texts.length > 1 ? "flex" : "block",
                          justifyContent:
                            row.texts.length > 1 ? "space-between" : "start",
                          ...row.style,
                        }}
                      >
                        {row.texts.map((text: any) => {
                          return (
                            <span style={{ ...text.style }}>{text.text}</span>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </>
        );
      })}
    </div>
  );
};
